import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { intakeQuestionnaireActions } from '../../../../../../../store';

import type { AppDispatch, RootState } from '../../../../../../../store';

export default function useIntakeNotAttendingSchool() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { intakeQuestionnaireId } = useParams<'intakeQuestionnaireId'>();
  const notAttendingSchool = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.not_attending_school ?? false,
  );
  const hasEducationInfo = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.education_info != null,
  );

  const setNotAttendingSchool = useCallback(
    async (nextNotAttendingSchool: boolean) => {
      if (!intakeQuestionnaireId) return;
      await dispatch(
        intakeQuestionnaireActions.setIntakeNotAttendingSchool({
          intakeQuestionnaireId,
          notAttendingSchool: nextNotAttendingSchool,
          getAccessTokenSilently,
        }),
      );
    },
    [dispatch, getAccessTokenSilently, intakeQuestionnaireId],
  );

  return { notAttendingSchool, hasEducationInfo, setNotAttendingSchool };
}
